import React from 'react';

interface CardSkeletonProps {
  lines?: number;
  showImage?: boolean;
  showAvatar?: boolean;
  showBadge?: boolean;
  className?: string;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({
  lines = 3,
  showImage = false,
  showAvatar = false,
  showBadge = false,
  className = '',
}) => {
  return (
    <div className={`bg-white rounded-xl shadow-md p-4 ${className}`}>
      <div className="flex items-start gap-3">
        {showAvatar && (
          <div className="h-10 w-10 rounded-full bg-gray-200 animate-pulse shrink-0" />
        )}
        {showImage && (
          <div className="h-32 w-full bg-gray-200 animate-pulse rounded-lg" />
        )}
        <div className="flex-1 space-y-2">
          {Array.from({ length: lines }).map((_, i) => (
            <div
              key={i}
              className="h-3 bg-gray-200 rounded-full animate-pulse"
              style={{
                width: `${Math.random() * 40 + 40}%`,
                opacity: 0.6 + i * 0.1,
              }}
            />
          ))}
        </div>
        {showBadge && (
          <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse shrink-0" />
        )}
      </div>
    </div>
  );
};

export default CardSkeleton;
